import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import BrandDashboard from './pages/BrandDashboard';
import LeadForm from './pages/LeadForm';
import LeadDetail from './pages/LeadDetail';
import BlankPage from './pages/BlankPage';
import MonthlyUploadDetail from './pages/MonthlyUploadDetail';
import { UiProvider } from './context/UiContext';
import './leadscore.css';

/**
 * Ported from the standalone Lead Quality Score project (same component tree
 * and route paths -- nested `<Routes>` here resolve relative to wherever the
 * parent `/lead-quality-score/*` route matched, so these paths are unchanged
 * from the original). Everything renders inside .rr-leadscore-scope, which
 * every selector in leadscore.css was mechanically prefixed with during the
 * port -- including its original global `*` reset -- so none of it can leak
 * into (or be affected by) the rest of the CRM.
 */
export default function LeadScoreApp() {
  return (
    <div className="rr-leadscore-scope">
      <UiProvider>
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/brands/:brandId" element={<BrandDashboard />} />
            <Route path="/brands/:brandId/monthly/:uploadId" element={<MonthlyUploadDetail />} />
            <Route path="/brands/:brandId/leads/new" element={<BlankPage />} />
            <Route path="/brands/:brandId/leads/:leadId/edit" element={<LeadForm />} />
            <Route path="/brands/:brandId/leads/:leadId" element={<LeadDetail />} />
          </Routes>
        </main>
      </UiProvider>
    </div>
  );
}
